const Permissions = () => {
    return {
        permissions: {
            associateAdvocates: ['afiore', 'sblake'],
            resource: ['gbaker']
        }
    }
};

export default Permissions;



/** WEBPACK FOOTER **
 ** ./src/data/permissions.js
 **/